import React, { useState, useEffect } from 'react';
import Messaging from './Messaging/Messaging.js';
import Contacts from './Contacts/Contacts.js';
import './App.css'
import NewContact from './Contacts/NewContact.js';
import StartModal from './StartModal/StartModal.js'
import personnages from './Personnages/Personnages.json'
import { Button } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css';

import backgroundMusic from './assets/bg_music.mp3'

var audio = new Audio(backgroundMusic);
audio.loop = true;
audio.volume = 0.15;

export default function App() {
  const [selectedContact, setSelectedContact] = useState("Alonzo Conti")
  const [contactList, setContactList] = useState([{ name: 'Alonzo Conti', number: "+393473456789" }, { name: 'Giuseppe Costa', number: "+393402345678" }, { name: '+3912345678', number: "+3912345678" }, { name: 'Lucia Bianchi', number: "+393484567890" }, { name: 'Alarme', number: "+3912345678" }])
  const [messagesList, setMessagesList] = useState(personnages)
  const [popUp, setPopUp] = useState(false)
  const [showContact, setShowContact] = useState(false)
  const [audioPlaying, setAudioPlaying] = useState(false)
  let mobile = window.innerWidth < 900
  const [apiKey, setApiKey] = useState("")
  const [validKey, setValidKey] = useState(false)

  useEffect(() => {
    var promise = audio.play()
    if (promise !== undefined) {
      promise.then(_ => {
        setAudioPlaying(true)
      }).catch(error => {
        setAudioPlaying(false)
        console.log(error)
      });
    }
  }, [])

  useEffect(() => {
    if (audioPlaying) {
      audio.play()
    } else {
      audio.pause()
    }
  }, [audioPlaying])

  return (
    <div className={popUp ? "app during-popup" : "app"}>
      {(!mobile || showContact) && <div className={mobile ? "contacts-container mobile" : "contacts-container"}>
        <NewContact popUp={popUp} setPopUp={setPopUp} contactList={contactList} setContactList={setContactList} messagesList={messagesList} />
        <Contacts contactList={contactList} selectedContact={selectedContact} setSelectedContact={setSelectedContact} setPopUp={setPopUp} setShowContact={setShowContact} />
      </div>
      }
      {mobile && <Button className="ui icon add-menu" onClick={() => { setShowContact(!showContact) }}><i className="align justify icon"></i></Button>}
      {(!mobile || !showContact) && <div className="messaging-container">
        <Messaging apiKey={apiKey} validKey={validKey} audioPlaying={audioPlaying} setAudioPlaying={setAudioPlaying} selectedContact={selectedContact} contactList={contactList} setContactList={setContactList} messagesList={messagesList} setMessagesList={setMessagesList} />
      </div>
      }
      {!validKey && <StartModal setApiKey={setApiKey} setValidKey={setValidKey} apiKey={apiKey} />}
    </div>
  );
}
